import PropTypes from 'prop-types';

const Input = ({
  label,
  type,
  labelPlacement = 'top',
  placeholder,
  value,
  onChange,
  required,
  error,
  inputClassName,
  labelClassName,
  parentClassName,
  errorClassName,
  disabled,
  ...rest
}) => {
  return (
    <div
      className={`flex ${labelPlacement === 'top' ? 'flex-col' : 'items-center gap-8 w-full'} ${parentClassName} text-base`}
    >
      {label && (
        <label className={`text-gray-700 font-bold mb-2 ${labelClassName}`}>
          {label}
          {required && <span className="text-red-500"> *</span>}
        </label>
      )}
      <input
        className={`border border-gray-400 text-black p-2 rounded-lg  ${disabled ? 'bg-gray-100 cursor-not-allowed opacity-70' : ''} ${labelPlacement === 'top' ? '' : 'w-full'} ${inputClassName} ${
          error ? 'border-red-500' : ''
        }`}
        type={type}
        placeholder={placeholder}
        value={value ?? ''}
        onChange={onChange}
        required={required}
        disabled={disabled}
        onKeyDown={(e) => {
          if (type === 'number' && ['e', 'E', '+', '-'].includes(e.key)) {
            e.preventDefault();
          }
        }}
        {...rest}
      />
      {error && (
        <p className={`mt-1 text-base text-red-500 ${errorClassName}`}>
          {typeof error === 'object' ? error.message : error}
        </p>
      )}
    </div>
  );
};

Input.propTypes = {
  label: PropTypes.string,
  type: PropTypes.string.isRequired,
  placeholder: PropTypes.string,
  value: PropTypes.string,
  onChange: PropTypes.func.isRequired,
  required: PropTypes.bool,
  error: PropTypes.string,
  inputClassName: PropTypes.string,
  labelPlacement: PropTypes.string,
  labelClassName: PropTypes.string,
  parentClassName: PropTypes.string,
  errorClassName: PropTypes.string,
  disabled: PropTypes.bool,
};

export default Input;

// import PropTypes from 'prop-types';
// import { useState, useEffect } from 'react';

// const Input = ({
//   label,
//   type,
//   labelPlacement = 'top',
//   placeholder,
//   value,
//   onChange,
//   required,
//   error,
//   inputClassName,
//   labelClassName,
//   parentClassName,
//   errorClassName,
//   disabled,
//   formatDisplay = true,
//   ...rest
// }) => {
//   const [displayValue, setDisplayValue] = useState(value || '');

//   useEffect(() => {
//     if (type === 'number' && formatDisplay) {
//       setDisplayValue(value ? Number(value).toLocaleString('en-IN') : '');
//     } else {
//       setDisplayValue(value || '');
//     }
//   }, [value, type, formatDisplay]);

//   const handleChange = (e) => {
//     const raw = e.target.value;

//     if (type === 'number' && formatDisplay) {
//       const numericValue = raw.replace(/[^0-9.]/g, '');
//       setDisplayValue(
//         numericValue ? Number(numericValue).toLocaleString('en-IN') : ''
//       );

//       if (typeof onChange === 'function') {
//         // Support both (name, value) and (e, value)
//         onChange.length === 2
//           ? onChange(e, numericValue) // case (e, value)
//           : onChange(e.target.name, numericValue); // case (name, value)
//       }
//     } else {
//       setDisplayValue(raw);
//       if (typeof onChange === 'function') {
//         // Normal text input usage
//         onChange.length === 2 ? onChange(e, raw) : onChange(e);
//       }
//     }
//   };

//   return (
//     <div
//       className={`flex ${
//         labelPlacement === 'top' ? 'flex-col' : 'items-center gap-8 w-full'
//       } ${parentClassName} text-base`}
//     >
//       {label && (
//         <label className={`text-gray-700 font-bold mb-2 ${labelClassName}`}>
//           {label}
//           {required && <span className="text-red-500">*</span>}
//         </label>
//       )}

//       <input
//         className={`border border-gray-400 text-black p-2 rounded-lg ${
//           disabled ? 'bg-gray-100 cursor-not-allowed opacity-70' : ''
//         } ${labelPlacement === 'top' ? '' : 'w-full'} ${inputClassName} ${
//           error ? 'border-red-500' : ''
//         }`}
//         type={type === 'number' && formatDisplay ? 'text' : type}
//         placeholder={placeholder}
//         value={displayValue}
//         onChange={handleChange}
//         required={required}
//         disabled={disabled}
//         {...rest}
//       />

//       {error && (
//         <p className={`mt-1 text-base text-red-500 ${errorClassName}`}>
//           {error}
//         </p>
//       )}
//     </div>
//   );
// };

// Input.propTypes = {
//   label: PropTypes.string,
//   type: PropTypes.string.isRequired,
//   placeholder: PropTypes.string,
//   value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
//   onChange: PropTypes.func.isRequired,
//   required: PropTypes.bool,
//   error: PropTypes.string,
//   inputClassName: PropTypes.string,
//   labelPlacement: PropTypes.string,
//   labelClassName: PropTypes.string,
//   parentClassName: PropTypes.string,
//   errorClassName: PropTypes.string,
//   disabled: PropTypes.bool,
//   formatDisplay: PropTypes.bool,
// };

// export default Input;
